import { css } from '@emotion/css';
import React, { CSSProperties } from 'react';
import { ReactComponent as Birthday } from '../../../assets/images/home/ic-birthday.svg';
import { ReactComponent as Leaf } from '../../../assets/images/mark-leaf.svg';
import { Notification } from '../../../models/Notification';

interface NotificationIconProps {
  type: Notification['type'];
  style?: CSSProperties;
}

export const NotificationIcon: React.FC<NotificationIconProps> = ({ type, style }) => {
  return (
    <div
      className={css`
        width: 64px;
        height: 64px;
        border-radius: 50%;
        background: ${bgColor(type)};
        transform: translateZ(0);
        @media (max-width: 320px), (max-height: 580px) {
          width: 56px;
          height: 56px;
        }
      `}
      style={style}
      aria-hidden={true}
    >
      {(() => {
        switch (type) {
          case 'birthday-today':
          case 'birthday-today-leap':
          case 'birthday-tomorrow':
            return <Birthday />;
          case 'update':
          case 'reaction-available':
          default:
            return <Leaf />;
        }
      })()}
    </div>
  );
};

function bgColor(type: Notification['type']) {
  switch (type) {
    case 'birthday-today':
    case 'birthday-today-leap':
    case 'birthday-tomorrow':
      return '#ffd0ae';
    case 'update':
    case 'reaction-available':
    default:
      return '#f5f1e3';
  }
}
